import React, { useState, useEffect, useRef } from "react";
import { ThemeCtx, ToastCtx, api, SEV_C, STAT_C, PAGE_SIZE, Pager, Card, Modal, Bdg, Dot, Av, AdminBadge, useToast, ConfirmDialog, usePagination } from "../shared.js";

export function PageAuditLog({user}){
  var T=React.useContext(ThemeCtx).T;
  var _logs=useState([]); var logs=_logs[0]; var setLogs=_logs[1];
  var _total=useState(0); var total=_total[0]; var setTotal=_total[1];
  var _search=useState(""); var search=_search[0]; var setSearch=_search[1];
  var _entity=useState(""); var entity=_entity[0]; var setEntity=_entity[1];
  var _action=useState(""); var action=_action[0]; var setAction=_action[1];
  var _pg=useState(0); var pg=_pg[0]; var setPg=_pg[1];
  var LIMIT=50;
  useEffect(function(){
    var params=new URLSearchParams({limit:LIMIT,offset:pg*LIMIT});
    if(search) params.set("search",search);
    if(entity) params.set("entity",entity);
    if(action) params.set("action",action);
    api.get("/audit?"+params.toString()).then(function(d){setLogs(d.logs||[]);setTotal(d.total||0);}).catch(function(){});
  },[search,entity,action,pg]);
  var AC={CREATE:T.success,UPDATE:"#3b82f6",DELETE:T.danger,UNLOCK:T.warning,RESET_PASSWORD:T.warning,BULK_UPDATE:"#8b5cf6"};
  var iStyle={padding:"8px 10px",background:T.inset,border:"1px solid "+T.border,borderRadius:8,color:T.text,fontSize:13,outline:"none"};
  return React.createElement("div",{style:{display:"flex",flexDirection:"column",gap:12}},
    React.createElement("div",{style:{display:"flex",gap:8,flexWrap:"wrap",alignItems:"center"}},
      React.createElement("input",{placeholder:"Search...",value:search,onChange:function(e){setSearch(e.target.value);setPg(0);},style:Object.assign({},iStyle,{flex:"1 1 160px"})}),
      React.createElement("select",{value:entity,onChange:function(e){setEntity(e.target.value);setPg(0);},style:iStyle},
        React.createElement("option",{value:""},"All entities"),
        ["vulnerability","user","pod","app_config","exception"].map(function(e){return React.createElement("option",{key:e,value:e},e);})
      ),
      React.createElement("select",{value:action,onChange:function(e){setAction(e.target.value);setPg(0);},style:iStyle},
        React.createElement("option",{value:""},"All actions"),
        ["CREATE","UPDATE","DELETE","UNLOCK","RESET_PASSWORD","BULK_UPDATE"].map(function(a){return React.createElement("option",{key:a,value:a},a);})
      ),
      React.createElement("span",{style:{fontSize:12,color:T.text3}},total+" entries")
    ),
    React.createElement(Card,{style:{padding:0,overflow:"hidden"}},
      React.createElement("table",{style:{width:"100%",borderCollapse:"collapse"}},
        React.createElement("thead",null,
          React.createElement("tr",{style:{background:T.inset}},
            ["Time","User","Action","Entity","ID","Detail"].map(function(h){
              return React.createElement("th",{key:h,style:{padding:"10px 12px",textAlign:"left",fontSize:11,color:T.text3,fontWeight:600,textTransform:"uppercase",letterSpacing:.5,whiteSpace:"nowrap"}},h);
            })
          )
        ),
        React.createElement("tbody",null,
          logs.length===0&&React.createElement("tr",null,React.createElement("td",{colSpan:6,style:{padding:"20px",textAlign:"center",color:T.text3,fontSize:13}},"No audit logs yet")),
          logs.map(function(l,i){
            return React.createElement("tr",{key:l.id,style:{borderTop:"1px solid "+T.border,background:i%2===0?"transparent":T.inset+"44"}},
              React.createElement("td",{style:{padding:"8px 12px",fontSize:11,color:T.text3,whiteSpace:"nowrap"}},new Date(l.created_at).toLocaleString()),
              React.createElement("td",{style:{padding:"8px 12px",fontSize:12,color:T.text}},
                React.createElement("div",null,l.user_name||"System"),
                React.createElement("div",{style:{fontSize:10,color:T.text3}},l.user_role)
              ),
              React.createElement("td",{style:{padding:"8px 12px"}},React.createElement(Bdg,{t:l.action,c:AC[l.action]||T.text3})),
              React.createElement("td",{style:{padding:"8px 12px",fontSize:12,color:T.text2}},l.entity||"—"),
              React.createElement("td",{style:{padding:"8px 12px",fontSize:12,color:T.accent,fontWeight:600}},l.entity_id||"—"),
              React.createElement("td",{style:{padding:"8px 12px",fontSize:11,color:T.text3,maxWidth:180,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}},
                (function(){try{var d=l.detail;if(!d)return "—";if(typeof d==="object")return JSON.stringify(d).slice(0,80);return String(d).slice(0,80);}catch(e){return "—";}})()
              )
            );
          })
        )
      )
    ),
    total>LIMIT&&React.createElement("div",{style:{display:"flex",justifyContent:"center",gap:8}},
      React.createElement("button",{onClick:function(){setPg(function(p){return Math.max(0,p-1);});},disabled:pg===0,style:{padding:"6px 12px",background:T.inset,color:T.text2,border:"1px solid "+T.border,borderRadius:6,cursor:"pointer",fontSize:12}},"Prev"),
      React.createElement("span",{style:{fontSize:12,color:T.text3,lineHeight:"30px"}},"Page ",pg+1," of ",Math.ceil(total/LIMIT)),
      React.createElement("button",{onClick:function(){setPg(function(p){return p+1;});},disabled:(pg+1)*LIMIT>=total,style:{padding:"6px 12px",background:T.inset,color:T.text2,border:"1px solid "+T.border,borderRadius:6,cursor:"pointer",fontSize:12}},"Next")
    )
  );
}

